import { render } from "./AbonnementsView.vue?vue&type=template&id=b4a466f2"
import script from "./AbonnementsView.vue?vue&type=script&lang=js"
export * from "./AbonnementsView.vue?vue&type=script&lang=js"

import "./AbonnementsView.vue?vue&type=style&index=0&id=b4a466f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__